import { useCallback } from "react";
import { IAppointmentsProgram } from "../services/types/utils.types";

function useTreatmentPlanFormValidation(form: IAppointmentsProgram) {
  const isValid = useCallback(() => {
    return (
      !!form.name &&
      form.appointmentsDurationsId > 0 &&
      form.appointmentsSequenceId > 0 &&
      form.countOfAppointments > 0 &&
      form.mediasId > 0
      // (form.fundingSourcesId ?? 0) > 0 &&
      // (form.treatmentTypesId ?? 0) > 0
      // form.roleId > 0
    );
  }, [form]);

  return { isValid };
}

export default useTreatmentPlanFormValidation;

